import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {FirebaseTokenService} from '../auth/firebase-token';
import {catchError, from, switchMap, throwError} from 'rxjs';
import {AuthReadyService} from '../auth/auth-ready.service';
import {USA_TOKEN_CLIENT_CREDENTIALS} from '../auth/client-credentials-context';
import {ClientCredentialsTokenService} from '../auth/client-credentials-token.service';

/*export const authInterceptor: HttpInterceptorFn = (req, next) => {

  // 🚨 No interceptar peticiones de login
  if (req.url.includes('login')) {
    return next(req);
  }

  const tokenService = inject(FirebaseTokenService);
  const authReady = inject(AuthReadyService);

  return from(authReady.waitUntilReady()).pipe(
    switchMap(() => from(tokenService.getFreshIdToken())),
    switchMap(token => {

      if (!token) {
        return next(req);
      }

      return next(
        req.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`
          }
        })
      );
    })
  );
};*/

export const authInterceptor: HttpInterceptorFn = (req, next) => {

  if (req.context.get(USA_TOKEN_CLIENT_CREDENTIALS)) {
    const clientCredentialsToken = inject(ClientCredentialsTokenService);

    return from(clientCredentialsToken.obtenerToken()).pipe(
      switchMap(token => next(req.clone({
        setHeaders: {Authorization: `Bearer ${token}`}
      }))),
      catchError(error => {
        if (!(error instanceof HttpErrorResponse) || error.status !== 401) {
          return throwError(() => error);
        }

        clientCredentialsToken.limpiar();
        return from(clientCredentialsToken.obtenerToken(true)).pipe(
          switchMap(token => next(req.clone({
            setHeaders: {Authorization: `Bearer ${token}`}
          })))
        );
      })
    );
  }

  // No interceptar peticiones de login
  if (req.url.includes('login')) {
    return next(req);
  }

  const tokenService = inject(FirebaseTokenService);
  const authReady = inject(AuthReadyService);

  return from(authReady.waitUntilReady()).pipe(
    switchMap(() => from(tokenService.getFreshIdToken())),
    switchMap(token => {

      const authReq = token
        ? req.clone({
            setHeaders: { Authorization: `Bearer ${token}` }
          })
        : req;

      return next(authReq).pipe(
        catchError(err => {

          if (err instanceof HttpErrorResponse && err.status === 401) {

            console.warn('Token expirado → refrescando...');

            return from(tokenService.forceRefresh()).pipe(
              switchMap(newToken => {

                if (!newToken) {
                  return throwError(() => err);
                }

                const retryReq = req.clone({
                  setHeaders: {
                    Authorization: `Bearer ${newToken}`
                  }
                });

                return next(retryReq);
              })
            );
          }

          return throwError(() => err);
        })
      );
    })
  );
};
